export default "__VITE_ASSET__wK6bpu1a__"